module.exports = __webpack_public_path__ + "static/media/DSC03765.cc8f372f.jpg";